<div class="container">
    <h1 mat-dialog-title class="dialog-title">{{ 'WARNING' | translate }}</h1>

    <mat-dialog-content>
    <p>{{ 'EMA_NOTIFICATION_CONFIRMATION' | translate }}</p>
    </mat-dialog-content>

    <mat-dialog-actions>
    <button mat-raised-button class="send-btn" (click)="confirm()">
        <mat-icon>smartphone</mat-icon>
        {{ 'SEND' | translate }}
    </button>
    <button mat-stroked-button class="cancel-btn" (click)="cancel()">
        <mat-icon>delete</mat-icon>
        {{ 'CANCEL' | translate }}
    </button>
    </mat-dialog-actions>
    <mat-dialog-content>
    <p class="server-text">{{ 'EMA_SERVERS_MESSAGE' | translate:{ servers: serversText } }}</p>
    </mat-dialog-content>
</div>